import { Box, Typography } from "@mui/material";
import { Dayjs } from "dayjs";
import { memo } from "react";
import { TimelineSlot } from "./timelineLayout";

const HOUR_COUNT = 24;

const hourLeftPercent = (hour: number): number => (hour / HOUR_COUNT) * 100;

export const HourRails = memo(() => (
  <Box
    sx={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      pointerEvents: "none",
    }}
  >
    {Array.from({ length: HOUR_COUNT + 1 }).map((_, hour) => (
      <Box
        // eslint-disable-next-line @eslint-react/no-array-index-key
        key={hour}
        sx={{
          position: "absolute",
          left: `${hourLeftPercent(hour)}%`,
          top: 0,
          bottom: 0,
          width: "1px",
          bgcolor: "divider",
          opacity: 0.1,
        }}
      />
    ))}
  </Box>
));
HourRails.displayName = "HourRails";

export const HourRailLabels = memo(
  ({ dayStart, slot }: { dayStart: Dayjs; slot?: TimelineSlot }) => (
    <Box
      sx={{
        position: "absolute",
        left: 0,
        right: 0,
        top: slot?.top ?? 0,
        ...(slot ? { height: slot.height } : { bottom: 0 }),
        pointerEvents: "none",
      }}
    >
      {Array.from({ length: HOUR_COUNT }).map((_, hour) => (
        <Typography
          // eslint-disable-next-line @eslint-react/no-array-index-key
          key={hour}
          variant="caption"
          sx={{
            position: "absolute",
            left: `calc(${hourLeftPercent(hour)}% + 4px)`,
            top: 0,
            bottom: 0,
            display: "flex",
            alignItems: "center",
            fontSize: "0.65rem",
            color: "text.secondary",
            whiteSpace: "nowrap",
          }}
        >
          {dayStart.add(hour, "hour").format("LT")}
        </Typography>
      ))}
    </Box>
  )
);
HourRailLabels.displayName = "HourRailLabels";
